import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import './theme.css';
import './chrome.css';

const links = [
  { label: 'Work', to: '/product' },
  { label: 'About', to: '/product/about' },
  { label: 'Contact', to: 'mailto:sami@samidenicola.com', external: true },
];

function ProductNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  const isWorkActive = location.pathname.startsWith('/product') && location.pathname !== '/product/about';

  return (
    <motion.header
      className={`ppnav ${scrolled ? 'ppnav--scrolled' : ''}`}
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className="ppnav__inner">
        <Link to="/product" className="ppnav__brand" aria-label="Samantha de Nicola — Product work">
          <span className="ppnav__brand-name">Samantha de Nicola</span>
          <span className="ppnav__brand-meta">Product</span>
        </Link>

        <nav className="ppnav__links" aria-label="Product portfolio">
          {links.map((l) =>
            l.external ? (
              <a
                key={l.label}
                href={l.to}
                className="ppnav__link"
                {...(l.to.startsWith('http') || l.to.endsWith('.pdf')
                  ? { target: '_blank', rel: 'noopener noreferrer' }
                  : {})}
              >
                {l.label}
              </a>
            ) : (
              <Link
                key={l.label}
                to={l.to}
                className={`ppnav__link ${
                  (l.to === '/product' ? isWorkActive : location.pathname === l.to) ? 'is-active' : ''
                }`}
              >
                {l.label}
              </Link>
            )
          )}
        </nav>

        <button
          className={`ppnav__toggle ${menuOpen ? 'is-open' : ''}`}
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          <span /><span />
        </button>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <motion.nav
            className="ppnav__mobile"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            aria-label="Product portfolio mobile"
          >
            {links.map((l, i) =>
              l.external ? (
                <a key={l.label} href={l.to} className="ppnav__mobile-link"
                  {...(l.to.startsWith('http') || l.to.endsWith('.pdf') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                  <span className="ppnav__mobile-num">0{i + 1}</span>{l.label}
                </a>
              ) : (
                <Link key={l.label} to={l.to} className="ppnav__mobile-link">
                  <span className="ppnav__mobile-num">0{i + 1}</span>{l.label}
                </Link>
              )
            )}
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
}

export default ProductNav;
